export default __webpack_public_path__ + "static/media/prelude.c1b392bc.mid";